/**
 * ????????API ???? ????.
 * axios ??????????(src/api/index.js)?????????? ????????,
 * ??? ????? index.js????????????????? ???????? Authorization ???????????????.
 *
 * ????? ???: axios ??????????????? 401 ?????? ????, ?????????????????? ???.
 */
import api from './index'

/* ================================================================
 * ????API
 * ================================================================ */

/**
 * ?????? ???? (??????????+ ?????????).
 *
 * @param {Object} params - { keyword, branchType, branchStatus, page, size }
 * @returns {Promise} { data: { items, total, page, size, totalPages }, code, message }
 */
export function getBranchList(params) {
  return api.get('/api/v1/branch', { params })
}

/**
 * ????????? ????.
 *
 * @param {string} branchCode - ????????
 * @returns {Promise} { branchCode, branchName, ..., admins, feePolicies, code, message }
 */
export function getBranchDetail(branchCode) {
  return api.get(`/api/v1/branch/${branchCode}`)
}

/**
 * ????????? (HQ ?????? ?????).
 * ??????? + ??? ?????? + ???????????(?????)?????? ??????????.
 *
 * @param {Object} data - CreateBranchRequest ?????
 * @returns {Promise} ???????????????? ?????
 */
export function createBranch(data) {
  return api.post('/api/v1/branch', data)
}

/**
 * ??????? ????.
 *
 * @param {string} branchCode - ??????????????
 * @param {Object} data - UpdateBranchRequest ?????
 * @returns {Promise} ??????????????? ?????
 */
export function updateBranch(branchCode, data) {
  return api.put(`/api/v1/branch/${branchCode}`, data)
}

/**
 * ???????? (soft delete, HQ ?????? ?????).
 *
 * @param {string} branchCode - ??????????????
 * @returns {Promise} { code, message }
 */
export function deleteBranch(branchCode) {
  return api.delete(`/api/v1/branch/${branchCode}`)
}

/* ================================================================
 * ??? ???(???) ?? ??
 * ================================================================ */

/**
 * ??? ???(??? ID) ?? ??.
 * ?? ? ?? ?? ?? ?? ? ??.
 *
 * @param {string} email - ??? ???
 * @returns {Promise} { code: 0 ????, 2011 ?? }
 */
export function checkAdminEmail(email) {
  return api.get('/api/v1/branch/check-admin-email', { params: { email: email?.trim() || '' } })
}

/* ================================================================
 * ?? ??? API
 * ================================================================ */

/**
 * ?? ??? ?? ??.
 *
 * @param {string} branchCode - ????????
 * @returns {Promise} { admins: [...], code, message }
 */
export function getAdminList(branchCode) {
  return api.get(`/api/v1/branch/${branchCode}/admins`)
}

/**
 * ?????????? ????.
 *
 * @param {string} branchCode - ????????????
 * @param {Object} data - { adminName, adminEmail, adminPassword, adminPosition, adminPhone }
 * @returns {Promise} ?????? ?? ????? ?????
 */
export function createBranchAdmin(branchCode, data) {
  return api.post(`/api/v1/branch/${branchCode}/admins`, data)
}

/**
 * ?????????? ??? ????.
 *
 * @param {string} branchCode - ????????
 * @param {string} branchAdminCode - ?????????????????
 * @param {Object} data - { adminName, adminPosition, adminPhone }
 * @returns {Promise} ?????? ?? ????? ?????
 */
export function updateBranchAdmin(branchCode, branchAdminCode, data) {
  return api.put(`/api/v1/branch/${branchCode}/admins/${branchAdminCode}`, data)
}

/**
 * ?????????? ????????? ????
 * HQ ?????? ????? ????? ????????? ?????????????????????
 *
 * @param {string} branchCode - ????????
 * @param {string} branchAdminCode - ????????????????? ???????????
 * @param {Object} data - { newPassword }
 * @returns {Promise} { code, message }
 */
export function updateBranchAdminPassword(branchCode, branchAdminCode, data) {
  return api.post(`/api/v1/branch/${branchCode}/admins/${branchAdminCode}/password`, data)
}

/**
 * ?????????? ???? (soft delete).
 *
 * @param {string} branchCode - ????????
 * @param {string} branchAdminCode - ?????????????????
 * @returns {Promise} { code, message }
 */
export function deleteBranchAdmin(branchCode, branchAdminCode) {
  return api.delete(`/api/v1/branch/${branchCode}/admins/${branchAdminCode}`)
}

/* ================================================================
 * ??????????? API
 * ================================================================ */

/**
 * ??????????????? ?? ????.
 *
 * @param {string} branchCode - ????????
 * @returns {Promise} { feePolicies: [...], code, message }
 */
export function getFeePolicyList(branchCode) {
  return api.get(`/api/v1/branch/${branchCode}/fee-policy`)
}

/**
 * ??????????? ???.
 *
 * @param {string} branchCode - ????????
 * @param {Object} data - { buyFeeRate, sellFeeRate, startDate, endDate }
 * @returns {Promise} ??????????? ?? ????? ?????
 */
export function createFeePolicy(branchCode, data) {
  return api.post(`/api/v1/branch/${branchCode}/fee-policy`, data)
}

/**
 * ??????????? ????.
 *
 * @param {string} branchCode - ????????
 * @param {number} policyId - ??????????ID
 * @param {Object} data - { buyFeeRate, sellFeeRate, startDate, endDate }
 * @returns {Promise} ??????????? ?? ????? ?????
 */
export function updateFeePolicy(branchCode, policyId, data) {
  return api.put(`/api/v1/branch/${branchCode}/fee-policy/${policyId}`, data)
}

/**
 * ??????????? ???? (?? ????).
 *
 * @param {string} branchCode - ????????
 * @param {number} policyId - ??????????ID
 * @returns {Promise} { code, message }
 */
export function deleteFeePolicy(branchCode, policyId) {
  return api.delete(`/api/v1/branch/${branchCode}/fee-policy/${policyId}`)
}
